export default "__VITE_ASSET__BJSrXxPM__"